import { instance } from './axios.instance';

// Visite déjà vue ? Même règle que /verify_tour de web (table tours), via l'API JWT : le premier appel
// l'enregistre comme vue et répond true, les suivants false. Endpoint absent (web pas encore déployé) ou
// erreur : on ne montre pas la visite.
export const verifyTour = async (tourName) => {
  try {
    const res = await instance.get('/tours/verify', { params: { tour_name: tourName }, suppressErrorToast: true });
    return res.data?.success === true;
  } catch (error) {
    return false;
  }
};
